// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2f5P8","question":"Question_question__3Fsye","description":"Question_description__2z8wK"};